import { Component, OnInit, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { JaldeeReportService } from 'src/app/services/jaldee-report.service';

@Component({
  selector: 'app-change-invoice-status-dialog',
  templateUrl: './change-invoice-status-dialog.component.html',
  styleUrls: ['./change-invoice-status-dialog.component.css']
})
export class ChangeInvoiceStatusDialogComponent implements OnInit {
  public changeInvoiceForm: UntypedFormGroup;
  api_error: any;
  api_success: string;
  invoiceDetails: any;
  btnDisabled = true;
  constructor(private formbuilder: UntypedFormBuilder, private matDialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any, private reportService: JaldeeReportService) { }

  ngOnInit() {
    this.invoiceDetails = this.data;
    this.changeInvoiceForm = this.formbuilder.group({
      invoiceChangeStatus: ''
    });
  }

  OnChangeInvoiceStatusSubmit() {

    this.reportService.changeInvoiceStatus(this.data.invoiceId, this.changeInvoiceForm.value.invoiceChangeStatus)
      .subscribe(res => {
        this.api_success = 'Invoice Status Updated Successfully';
        setTimeout(() => {
          this.matDialogRef.close();
        }, 2000);

      },
        (error) => {
          this.api_error = error.error;
        });
  }
  radioChange() {
    console.log(this.changeInvoiceForm.get('invoiceChangeStatus').value);
 if ( (this.changeInvoiceForm.get('invoiceChangeStatus').value) !== ' ' ) {
  this.btnDisabled = false;
 } else {
  this.btnDisabled = true;
 }

 }

}
